<!-- <mat-toolbar fxLayout="column" color="primary" id="footer" fxLayoutAlign="space-between center"> -->
<mat-toolbar fxLayout="column" id="footer" fxLayoutAlign="space-between center">
    <div fxFlexAlign="end">
        <div class="mat-caption mat-typography no-margin">
            <mat-icon aria-label="Copyright">copyright</mat-icon> {{ today.getFullYear() }}
            <a href="{{ companyUrl }}" target="_blank">{{ company }}</a>
            v{{ version }}
        </div>
    </div>
</mat-toolbar>